export default "__VITE_ASSET__jxa1mgLtTkWQsdf0ciZOLw__"